import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../utils/translations';
import Header from './Header';
import Footer from './Footer';
import Industries from './Industries';
import SEOHead from './SEOHead';
import { Factory, Car, Truck, Printer } from 'lucide-react';

const IndustriesPage = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title={language === 'en' ? 'Industries We Serve - LAIMU Trantor | Automotive, Manufacturing, Logistics' : 'Industrias que Servimos - LAIMU Trantor | Automotriz, Manufactura, Logística'}
        description={language === 'en' ? 'LAIMU Trantor serves automotive, manufacturing, logistics, and printing industries with specialized business management solutions tailored to each sector.' : 'LAIMU Trantor sirve a las industrias automotriz, manufactura, logística e impresión con soluciones de gestión empresarial especializadas para cada sector.'}
        url="/industries"
      />
      <Header />
      
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-br from-white via-gray-50 to-blue-50">
        <div className="container mx-auto px-4 md:px-6">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <div className="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium mb-6" style={{ backgroundColor: '#e0f2fe', color: '#115d7b' }}>
              <Factory className="w-4 h-4 mr-2" />
              {language === 'en' ? 'Industry Expertise' : 'Experiencia por Industria'}
            </div>
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
              {language === 'en' ? 'Specialized Solutions for Every Industry' : 'Soluciones Especializadas para Cada Industria'}
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              {language === 'en' 
                ? 'Deep industry knowledge combined with cutting-edge technology to solve the unique challenges of your sector.'
                : 'Conocimiento profundo de la industria combinado con tecnología de vanguardia para resolver los desafíos únicos de tu sector.'
              }
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/demo"
                className="px-8 py-4 text-white rounded-lg transition-colors font-bold text-lg shadow-lg"
                style={{ backgroundColor: '#115d7b' }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#0f5269'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#115d7b'}
              >
                {language === 'en' ? 'See Industry Demo' : 'Ver Demo por Industria'}
              </a>
              <a
                href="/success-cases"
                className="px-8 py-4 border-2 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-bold text-lg"
                style={{ borderColor: '#115d7b' }}
              >
                {language === 'en' ? 'Success Stories' : 'Casos de Éxito'}
              </a>
            </div>
          </div>

          {/* Industry Icons Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
            <div className="bg-white p-6 rounded-xl shadow-lg text-center hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Car className="w-8 h-8 text-blue-600" />
              </div>
              <h3 className="font-bold text-gray-900">
                {language === 'en' ? 'Automotive' : 'Automotriz'}
              </h3>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg text-center hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Factory className="w-8 h-8 text-green-600" />
              </div>
              <h3 className="font-bold text-gray-900">
                {language === 'en' ? 'Manufacturing' : 'Manufactura'}
              </h3>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg text-center hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Truck className="w-8 h-8 text-purple-600" />
              </div>
              <h3 className="font-bold text-gray-900">
                {language === 'en' ? 'Logistics' : 'Logística'}
              </h3>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg text-center hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Printer className="w-8 h-8 text-orange-600" />
              </div>
              <h3 className="font-bold text-gray-900">
                {language === 'en' ? 'Printing' : 'Impresión'}
              </h3>
            </div>
          </div>
        </div>
      </section>

      <Industries />
      <Footer />
    </div>
  );
};

export default IndustriesPage;